import React from "react";
import ReactTable from "react-table";

const ATable = (props) => {
  return (
    <div id="tran-table">
      <ReactTable
        className="-striped -highlight"
        data={props.tableData}
        columns={props.columns}
        defaultPageSize={props.defaultPageSize || 10}
        pageSize={props.pageSize}
        noDataText={props.noDataText}
        showPagination={props.showPagination || true}
        resizable={props.resizable || true}
        getTdProps={(state, rowInfo, column, instance) => {
          return {
            onClick: (e) => {
              if (rowInfo) {
                props.onRowClick(rowInfo.index);
              }
            },
          };
        }}
        onChange={props.onChange || undefined}
        loading={props.loading}
        {...props}
      />
    </div>
  );
};

export default ATable;



// WEBPACK FOOTER //
// ./src/components/common/table.js